import { render, staticRenderFns } from "./FeedPage.vue?vue&type=template&id=d3722126&scoped=true&"
import script from "./FeedPage.vue?vue&type=script&lang=js&"
export * from "./FeedPage.vue?vue&type=script&lang=js&"
import style0 from "./FeedPage.vue?vue&type=style&index=0&id=d3722126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3722126",
  null
  
)

export default component.exports